"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROICalculatorMenu = void 0;
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var WidgetMenuButton_1 = __importDefault(require("../WidgetMenuButton"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var StyleShortCutContainer_1 = __importDefault(require("Common/AtomicUI/StyleShortCutContainer/StyleShortCutContainer"));
var lodash_1 = require("lodash");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var ROICalculatorMenu = (function (_super) {
    __extends(ROICalculatorMenu, _super);
    function ROICalculatorMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderColorPalette = function (label, selectedColor, onChange) {
            return (react_1.default.createElement("div", { className: "style-shortcut__section" },
                react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, label),
                react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                    react_1.default.createElement(ColorPalette_1.default, { presetColors: _this.props.brandStore.colorsWithThemeIndex, onColorChange: onChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)(selectedColor, _this.props.brandStore.colorsWithThemeIndex), type: "content" }))));
        };
        _this.handleChangeTintColor = function (color) {
            var nextStyles = (0, lodash_1.cloneDeep)(_this.styles);
            nextStyles.tint.color = color;
            _this.styles = nextStyles;
        };
        _this.handleChangeBackgroundColor = function (color) {
            var nextStyles = (0, lodash_1.cloneDeep)(_this.styles);
            nextStyles.background.color = color;
            nextStyles.textColor = (0, ColorUtils_1.shouldUseDarkText)(color.value) ? "dark" : "light";
            _this.styles = nextStyles;
        };
        _this.handleChangeOpacity = function (value) {
            var nextStyles = (0, lodash_1.cloneDeep)(_this.styles);
            nextStyles.tint.opacity = value;
            _this.styles = nextStyles;
        };
        _this.handleChangeImageBlur = function (value) {
            var nextStyles = (0, lodash_1.cloneDeep)(_this.styles);
            nextStyles.background.imageBlur = value;
            _this.styles = nextStyles;
        };
        return _this;
    }
    ROICalculatorMenu.prototype.render = function () {
        var _a = this.props, onDelete = _a.onDelete, onToggleStylePanel = _a.onToggleStylePanel, showStylePanel = _a.showStylePanel, hasBackgroundImage = _a.hasBackgroundImage, showStyleMenuButton = _a.showStyleMenuButton;
        var stylePanelTintSettings = (react_1.default.createElement(react_1.default.Fragment, null,
            this.renderColorPalette("Tint color", this.styles.tint.color, this.handleChangeTintColor),
            react_1.default.createElement(kaleidoscope_1.SliderInput, { label: "Tint opacity", handleValueChange: this.handleChangeOpacity, theme: kaleidoscope_1.SliderTheme.Dark, initialInputValue: this.styles.tint.opacity, maximum: 100 }),
            react_1.default.createElement(kaleidoscope_1.SliderInput, { label: "Background image blur", handleValueChange: this.handleChangeImageBlur, theme: kaleidoscope_1.SliderTheme.Dark, initialInputValue: this.styles.background.imageBlur, maximum: 30 })));
        var styleBackgroundColourSettings = (react_1.default.createElement(react_1.default.Fragment, null, this.renderColorPalette("Background color", this.styles.background.color, this.handleChangeBackgroundColor)));
        return (react_1.default.createElement("div", { className: "roi-calculator-menu editor-toolbar" },
            showStyleMenuButton && (react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Styles, null), onMouseDown: function (event) {
                    onToggleStylePanel();
                    event.preventDefault();
                } })),
            react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Delete, null), onMouseDown: onDelete, isDestructive: true }),
            react_1.default.createElement("div", { className: "contextual-roi-style", onMouseDown: function (event) { return event.stopPropagation(); }, contentEditable: false }, showStylePanel && (react_1.default.createElement(StyleShortCutContainer_1.default, { dark: true }, hasBackgroundImage ? stylePanelTintSettings : styleBackgroundColourSettings)))));
    };
    Object.defineProperty(ROICalculatorMenu.prototype, "styles", {
        get: function () {
            return this.props.blockStore.blockStyleStore.getElementStyle("roiCalculator");
        },
        set: function (next) {
            this.props.blockStore.blockStyleStore.setElementStyle("roiCalculator", next);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], ROICalculatorMenu.prototype, "styles", null);
    ROICalculatorMenu = __decorate([
        mobx_react_1.observer
    ], ROICalculatorMenu);
    return ROICalculatorMenu;
}(react_1.default.Component));
exports.ROICalculatorMenu = ROICalculatorMenu;
